import React from "react";
import styled from "@emotion/styled";
import { useEditor, useNode, UserComponent, Element } from "@craftjs/core";
import { Column } from "./Column";
import { ColumnsSettings } from "./ColumnsSettings";
import { BuilderBlock, NoBlock } from "@uiComponents/index";
import { defaultStyleProps } from "@uiComponents/shared";

const ColumnsStyled = styled.div`
  display: flex;
`;
export const Columns: UserComponent<any> = ({ children }) => {
  const {
    connectors: { connect, drag },
    setProp,
  } = useNode();

  return (
    <>
      <BuilderBlock ref={(dom: any) => connect(drag(dom))}>
        <ColumnsStyled>
          <Element is={Column} id="col_1" canvas></Element>
          <Element is={Column} id="col_2" canvas></Element>
        </ColumnsStyled>
      </BuilderBlock>
    </>
  );
};

Columns.craft = {
  displayName: "Columns",
  props: {},

  related: {
    toolbar: ColumnsSettings,
  },
};

Columns.defaultProps = defaultStyleProps;
